import Model, { ID } from 'src/models/Model'

export default class UpdatePaymentMethodUser extends Model {
  static name = 'UpdatePaymentMethodUser'

  static define () {
    this.fields = {
      id: {
        type: ID,
        output: true
      },
      token: {
        type: String
      },

      firstName: {
        type: String,
        output: true
      },
      lastName: {
        type: String,
        output: true
      },
      email: {
        type: String,
        output: true
      },

      defaultPaymentMethodBrand: {
        type: String,
        output: true
      },
      defaultPaymentMethodLast4: {
        type: String,
        output: true
      },

      hasPendingCharge: {
        type: Boolean,
        output: true
      },
      lastFailureCode: {
        type: String,
        output: true
      },
      lastFailureMessage: {
        type: String,
        output: true
      },
      pendingAmount: {
        type: Number,
        output: true,
        default: 0
      },

      attachPaymentMethodId: {
        type: String,
        input: true
      },
      stripeSetupIntentClientSecret: {
        type: String,
        output: true,
        excludeFromDefault: true
      },
      action: {
        type: String,
        input: true,
        default: null
      }
    }

    this.computed = {
      name () {
        return this.firstName + ' ' + this.lastName
      }
    }

    this.queries = {
      findUpdatePaymentMethodUserByToken: {
        arguments: {
          token: {
            type: String,
            required: true
          }
        },
        results: {
          user: UpdatePaymentMethodUser
        }
      }
    }
  }

  async createSetupIntent (terminal = false, errorHandler) {
    // Default error handler
    if (!errorHandler) {
      errorHandler = errors => {
        console.log(errors)
      }
    }

    let errors = this.errors

    if (errors) {
      errorHandler(errors)
      return
    }

    // Set the action we want the server to execute
    let action
    if (terminal) {
      action = 'create_terminal_setup_intent'
    } else {
      action = 'create_setup_intent'
    }

    const intentUser = new UpdatePaymentMethodUser({
      token: this.token,
      action
    }, {
      fields: ['token', 'stripeSetupIntentClientSecret']
    })

    try {
      const result = await intentUser.save()
      if (result.errors.length) {
        errors = result.errors
      }
    } catch (error) {
      errors = [error]
    }

    if (this.isLocal && intentUser.isRemote) {
      this.id = intentUser.id
    }

    if (errors) {
      errorHandler(errors)
      return
    }

    return intentUser.stripeSetupIntentClientSecret
  }

  async updateDefaultPaymentMethodFromStripe () {
    this.action = 'update_default_payment_method_from_stripe'

    try {
      await this.save()
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async removeDefaultPaymentMethod () {
    this.action = 'remove_default_payment_method'

    try {
      await this.save()
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async attachPaymentMethod (paymentMethodId) {
    this.attachPaymentMethodId = paymentMethodId

    this.action = 'attach_payment_method'

    try {
      await this.save()
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async retryFailedPayments () {
    this.action = 'retry_failed_payments'

    try {
      await this.save()
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }
}
